export class RemitoCreationDetails {
  public solicitante: Array<Solicitante>;
  public transporte: Array<IdDescModel>;
  public motivo: Array<IdDescModel>;
  public destinatario: Array<IdDescModel>;
}

export class Solicitante {
  public id: string;
  public name: string;
  public almacen: IdDescModel;
  public dock: IdDescModel;
}

export class IdDescModel {
  public id: string;
  public desc: string;
  public city: string;
  public estado: boolean;
}

export class Clase {
  id: string;
  viewValue: string;
}
